import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { theme } from '@garnish/constants';
import { Container, useResponsive } from '@garnish/core';

/**
 * Container to be used for both challenges and rewards rails and empty states.
 * The goal is to have a single implementation shared amongst the four usages.
 * So as to avoid discrepancies in margins between rail and empty states.
 */
export const LoyaltyHomeChallengesRewardsContainer = (props: ViewProps) => {
  const { children, style, ...restProps } = props;

  const { match, minWidth } = useResponsive();

  const containerStyle = [
    styles.forestBackground,
    style,
    match([styles.containerXS, styles.containerSM]),
    minWidth.isLG && styles.containerStaticSpacingLG,
  ];

  return (
    <View style={[styles.forestBackground, style, styles.wrapperStyle]}>
      <Container style={[containerStyle, style]} {...restProps}>
        {children}
      </Container>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const RAIL_SPACING_LG = theme.spacing['30'];

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  forestBackground: {
    backgroundColor: theme.colors.FOREST,
  },
  wrapperStyle: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  containerXS: {
    paddingVertical: theme.spacing['10'],
  },
  containerSM: {
    paddingVertical: theme.spacing['10'],
    gap: theme.spacing['6'],
  },
  containerLG: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  containerStaticSpacingLG: {
    paddingHorizontal: RAIL_SPACING_LG,
  },
});
